<template>
  <v-dialog
    v-model="show"
    @click:outside="closeModal"
    width="800"
  >
    <v-card>
    <!-- <h1>{{setting}}</h1> -->
    <v-card-title 
        class="text-h5 white--text"
        style="background-color:#5087e6;"
    >
      操作紀錄
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
      >
      </v-data-table> 

    </v-card-text>
      <v-divider></v-divider>

      <v-card-actions >
        <v-spacer></v-spacer>

        <v-btn
          text
          @click="closeModal"
        >
          關閉
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'HistoryModal',
    props: {
      headers: Array,
      items: Array,
    },
    data: function(){
      return {
        show: true
      }
    },
    created(){
        console.log('history_modal',this.show)
    },
    methods: {
      closeModal(){
        this.show = false
        this.$emit('close')
      }
    }
  }

</script>